import { lazy } from "react";
import { RoutesConst } from "../../utils/constants";

const DashboardPage = lazy(() => import("../../pages/dashboard"));

const SubscriptionsPage = lazy(() => import("../../pages/subscriptions"));

const ContentCategoryPage = lazy(() => import("../../pages/content/category"));
const ContentViewCategoryPage = lazy(
  () => import("../../pages/content/subs/view-category"),
);

const ProgrammesPage = lazy(() => import("../../pages/content/programmes"));
const CreateProgrammePage = lazy(
  () => import("../../pages/content/subs/create-programme"),
);
const ManageProgrammePage = lazy(
  () => import("../../pages/content/subs/manage-programme"),
);

const FilesPage = lazy(() => import("../../pages/content/files"));
const CreateFilePage = lazy(
  () => import("../../pages/content/subs/create-file"),
);

const QuizPage = lazy(() => import("../../pages/quiz"));
const QuizCreatePage = lazy(() => import("../../pages/quiz/sub/create"));
const QuizEditPage = lazy(() => import("../../pages/quiz/sub/edit"));

const BadgesPage = lazy(() => import("../../pages/badges"));

const UsersPage = lazy(() => import("../../pages/users"));
const UsersViewChildrenProfilePage = lazy(
  () => import("../../pages/users/subs/viewChildrenProfile"),
);

const LeaderboardPage = lazy(() => import("../../pages/leaderboard"));

const StoryStopPage = lazy(() => import("../../pages/story-stop"));
const CreateStoryStopPage = lazy(
  () => import("../../pages/story-stop/sub/create"),
);

const PledgePage = lazy(() => import("../../pages/pledge"));
const CreatePledgePage = lazy(() => import("../../pages/pledge/sub/create"));

const GameStopPage = lazy(() => import("../../pages/game-stop"));
const CreateGameStopPage = lazy(
  () => import("../../pages/game-stop/sub/create"),
);

export const privateRoutes = [
  {
    name: "Dashboard",
    path: RoutesConst.dashboard,
    component: DashboardPage,
  },

  //   SUBSCRIPTIONS
  {
    name: "Subscriptions",
    path: RoutesConst.subscriptions,
    component: SubscriptionsPage,
  },
  // Leader Board
  {
    name: "Leaderboard",
    path: RoutesConst.leaderboard,
    component: LeaderboardPage,
  },

  //   CONTENT
  {
    name: "Content Topics",
    path: RoutesConst.topics,
    component: ContentCategoryPage,
  },
  {
    name: "Content View Topic",
    path: RoutesConst.viewTopic(),
    component: ContentViewCategoryPage,
  },
  {
    name: "Content Programmes",
    path: RoutesConst.programmes,
    component: ProgrammesPage,
  },
  {
    name: "Create Content Programme",
    path: RoutesConst.createProgramme,
    component: CreateProgrammePage,
  },
  {
    name: "Manage Content Programme",
    path: RoutesConst.viewProgramme(),
    component: ManageProgrammePage,
  },
  {
    name: "Content Files",
    path: RoutesConst.file,
    component: FilesPage,
  },
  {
    name: "Create Content File",
    path: RoutesConst.createFile,
    component: CreateFilePage,
  },

  // Quiz
  {
    name: "Quiz List",
    path: RoutesConst.quiz,
    component: QuizPage,
  },
  {
    name: "Quiz Create",
    path: RoutesConst.createQuiz,
    component: QuizCreatePage,
  },
  {
    name: "Quiz Edit",
    path: RoutesConst.editQuiz(),
    component: QuizEditPage,
  },

  // Badges
  {
    name: "Badges List",
    path: RoutesConst.badges,
    component: BadgesPage,
  },

  // Users
  {
    name: "Users List",
    path: RoutesConst.users,
    component: UsersPage,
  },
  {
    name: "Users View Children Profile List",
    path: RoutesConst.viewUserChildren(),
    component: UsersViewChildrenProfilePage,
  },
  // { name: "Test Page", path: RoutesConst.test, component: TestPage },
  {
    name: "Story Stop List",
    path: RoutesConst.storyStop,
    component: StoryStopPage,
  },
  {
    name: "Story Stop Create",
    path: RoutesConst.createStoryStop,
    component: CreateStoryStopPage,
  },
  {
    name: "Story Stop Edit",
    path: RoutesConst.editStoryStop(),
    component: CreateStoryStopPage,
  },
  {
    name: "Pledge List",
    path: RoutesConst.pledge,
    component: PledgePage,
  },
  {
    name: "Pledge Create",
    path: RoutesConst.createPledge,
    component: CreatePledgePage,
  },
  {
    name: "Pledge Edit",
    path: RoutesConst.editPledge(),
    component: CreatePledgePage,
  },
  {
    name: "GameStop List",
    path: RoutesConst.gameStop,
    component: GameStopPage,
  },
  {
    name: "GameStop Create",
    path: RoutesConst.createGameStop,
    component: CreateGameStopPage,
  },
  {
    name: "GameStop Edit",
    path: RoutesConst.editGameStop(),
    component: CreateGameStopPage,
  },
];
